<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-3">
            <h5 class="mb-3">数据报表</h5>

            <!-- 第一行筛选 -->
            <div class="row g-2 align-items-end mb-2">
              <!-- 管理员：按账号查询 -->
              <div v-if="isAdmin" class="col-md-2">
                <label class="form-label text-xs mb-1">账号</label>
                <select v-model="filters.userId" class="form-control form-control-sm" @change="onUserChange">
                  <option value="">全部账号</option>
                  <option v-for="u in normalUsers" :key="u.id" :value="u.id">{{ u.username }}</option>
                </select>
              </div>

              <!-- 网站筛选 -->
              <div class="col-md-2">
                <label class="form-label text-xs mb-1">网站</label>
                <select v-model="filters.website" class="form-control form-control-sm" @change="onWebsiteChange">
                  <option value="">全部网站</option>
                  <option v-for="s in websiteOptions" :key="s.name" :value="s.name">{{ s.name }}</option>
                </select>
              </div>

              <!-- 国家筛选（选中网站后动画显示） -->
              <transition name="filter-drop">
                <div v-if="filters.website" class="col-md-2">
                  <label class="form-label text-xs mb-1">国家</label>
                  <select v-model="filters.country" class="form-control form-control-sm" @change="loadData">
                    <option value="">全部国家</option>
                    <option v-for="c in countryOptions" :key="c" :value="c">{{ c }}</option>
                  </select>
                </div>
              </transition>

              <!-- 广告位筛选（选中网站后动画显示） -->
              <transition name="filter-drop">
                <div v-if="filters.website" class="col-md-2">
                  <label class="form-label text-xs mb-1">广告位</label>
                  <select v-model="filters.adUnit" class="form-control form-control-sm" @change="loadData">
                    <option value="">全部广告位</option>
                    <option v-for="a in adUnitOptions" :key="a" :value="a">{{ a }}</option>
                  </select>
                </div>
              </transition>

              <!-- 开始日期 -->
              <div class="col-md-2">
                <label class="form-label text-xs mb-1">开始日期</label>
                <input v-model="filters.start" type="date" class="form-control form-control-sm" />
              </div>

              <!-- 结束日期 -->
              <div class="col-md-2">
                <label class="form-label text-xs mb-1">结束日期</label>
                <input v-model="filters.end" type="date" class="form-control form-control-sm" />
              </div>

              <!-- 查询 & 导出按钮 -->
              <div class="col-md-auto d-flex gap-2">
                <button
                  class="btn btn-primary btn-sm mb-0"
                  :disabled="tableLoading"
                  @click="loadData"
                >
                  查询
                </button>
                <button
                  class="btn btn-success btn-sm mb-0"
                  :disabled="!rows.length"
                  @click="exportCSV"
                >
                  导出
                </button>
              </div>
            </div>

            <!-- 第二行：显示维度 checkbox -->
            <div class="row g-2 align-items-center mt-1">
              <div class="col-auto">
                <div class="form-check mb-0">
                  <input
id="dim-date" v-model="filters.showDate" class="form-check-input"
                    type="checkbox" @change="loadData" />
                  <label for="dim-date" class="form-check-label text-sm">显示日期</label>
                </div>
              </div>
              <div class="col-auto">
                <div class="form-check mb-0">
                  <input
id="dim-country" v-model="filters.dimensions" class="form-check-input"
                    type="checkbox" value="country"
                    :disabled="countryOptions.length === 0"
                    @change="loadData" />
                  <label
for="dim-country" class="form-check-label text-sm"
                    :class="{ 'text-muted': countryOptions.length === 0 }">
                    显示国家
                    <span v-if="countryOptions.length === 0" class="text-xs text-warning ms-1">（不支持）</span>
                  </label>
                </div>
              </div>
              <div class="col-auto">
                <div class="form-check mb-0">
                  <input
id="dim-adunit" v-model="filters.dimensions" class="form-check-input"
                    type="checkbox" value="adunit"
                    :disabled="adUnitOptions.length === 0"
                    @change="loadData" />
                  <label
for="dim-adunit" class="form-check-label text-sm"
                    :class="{ 'text-muted': adUnitOptions.length === 0 }">
                    显示广告位
                    <span v-if="adUnitOptions.length === 0" class="text-xs text-warning ms-1">（不支持）</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div v-if="error" class="px-4 pb-2">
            <div class="alert alert-danger text-white mb-0 text-sm py-2" role="alert">
              {{ error }}
            </div>
          </div>

          <div class="table-responsive">
            <table v-if="rows.length > 0" id="datatable-revenue" class="table table-flush">
              <thead class="thead-light">
                <tr>
                  <th v-if="filters.dimensions.includes('country')" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">国家</th>
                  <th v-if="filters.dimensions.includes('adunit')" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">广告位</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">网站</th>
                  <th v-if="filters.showDate" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">日期</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">请求</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">匹配请求</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">覆盖率</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">曝光数</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">点击数</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">CTR</th>
                  <th v-if="isAdmin" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">原eCPM</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">eCPM</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">分成前收益</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">分成后收益</th>
                  <th v-if="isAdmin" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">实际收益</th>
                  <th v-if="isAdmin" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">利润</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">曝光率</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in rows" :key="idx">
                  <td v-if="filters.dimensions.includes('country')" class="text-sm font-weight-normal">{{ row.country || '-' }}</td>
                  <td v-if="filters.dimensions.includes('adunit')" class="text-sm font-weight-normal">{{ row.ad_unit || '-' }}</td>
                  <td class="text-sm font-weight-normal">{{ row.website }}</td>
                  <td v-if="filters.showDate" class="text-sm font-weight-normal">{{ row.date }}</td>
                  <td class="text-sm font-weight-normal text-end">{{ row.requests.toLocaleString() }}</td>
                  <td class="text-sm font-weight-normal text-end">{{ row.matched_requests.toLocaleString() }}</td>
                  <td class="text-sm font-weight-normal text-end">{{ formatPct(row.coverage) }}</td>
                  <td class="text-sm font-weight-normal text-end">{{ row.impressions.toLocaleString() }}</td>
                  <td class="text-sm font-weight-normal text-end">{{ row.clicks.toLocaleString() }}</td>
                  <td class="text-sm font-weight-normal text-end">{{ formatPct(row.ctr) }}</td>
                  <td v-if="isAdmin" class="text-sm font-weight-normal text-end text-muted">{{ formatECPM(row.original_ecpm) }}</td>
                  <td class="text-sm font-weight-normal text-end">{{ formatECPM(row.ecpm) }}</td>
                  <td class="text-sm font-weight-normal text-end">{{ formatAmount(row.pre_share_revenue) }}</td>
                  <td class="text-sm font-weight-bold text-end text-success">{{ formatAmount(row.post_share_revenue) }}</td>
                  <td v-if="isAdmin" class="text-sm font-weight-normal text-end">{{ formatAmount(row.actual_revenue) }}</td>
                  <td v-if="isAdmin" class="text-sm font-weight-bold text-end text-warning">{{ formatAmount(row.profit) }}</td>
                  <td class="text-sm font-weight-normal text-end">{{ formatPct(row.fill_rate) }}</td>
                </tr>
              </tbody>
              <tfoot v-if="totals">
                <tr class="total-row">
                  <td
:colspan="(filters.showDate ? 2 : 1) + (filters.dimensions.includes('country') ? 1 : 0) + (filters.dimensions.includes('adunit') ? 1 : 0)"
                      class="text-sm font-weight-bold text-end">合计</td>
                  <td class="text-sm font-weight-bold text-end">{{ totals.requests.toLocaleString() }}</td>
                  <td class="text-sm font-weight-bold text-end">{{ totals.matched_requests.toLocaleString() }}</td>
                  <td class="text-sm font-weight-bold text-end">—</td>
                  <td class="text-sm font-weight-bold text-end">{{ totals.impressions.toLocaleString() }}</td>
                  <td class="text-sm font-weight-bold text-end">{{ totals.clicks.toLocaleString() }}</td>
                  <td class="text-sm font-weight-bold text-end">—</td>
                  <td v-if="isAdmin" class="text-sm font-weight-bold text-end">—</td>
                  <td class="text-sm font-weight-bold text-end">—</td>
                  <td class="text-sm font-weight-bold text-end">{{ formatAmount(totals.pre_share_revenue) }}</td>
                  <td class="text-sm font-weight-bold text-end text-success">{{ formatAmount(totals.post_share_revenue) }}</td>
                  <td v-if="isAdmin" class="text-sm font-weight-bold text-end">{{ formatAmount(totals.actual_revenue) }}</td>
                  <td v-if="isAdmin" class="text-sm font-weight-bold text-end text-warning">{{ formatAmount(totals.profit) }}</td>
                  <td class="text-sm font-weight-bold text-end">—</td>
                </tr>
              </tfoot>
            </table>

            <!-- 骨架屏加载动画 -->
            <div v-else-if="tableLoading" class="px-4 py-3">
              <div v-for="i in 7" :key="i" class="skeleton-row d-flex gap-2 mb-2" :style="{ opacity: 1 - i * 0.1 }">
                <div class="skeleton-cell" style="width:14%"></div>
                <div class="skeleton-cell" style="width:9%"></div>
                <div class="skeleton-cell" style="width:7%"></div>
                <div class="skeleton-cell" style="width:7%"></div>
                <div class="skeleton-cell" style="width:7%"></div>
                <div class="skeleton-cell" style="width:7%"></div>
                <div class="skeleton-cell" style="width:9%"></div>
                <div class="skeleton-cell" style="width:9%"></div>
                <div class="skeleton-cell flex-grow-1"></div>
              </div>
            </div>
            <div v-else class="text-center py-5 text-muted text-sm">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchRevenueList, fetchRevenueWebsites, fetchRevenueOptions, fetchUsers } from "../../api/index.js";

export default {
  name: "DataTables",
  data() {
    const today = new Date();
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 29);
    return {
      tableLoading: false,
      error: null,
      rows: [],
      websiteOptions: [],
      countryOptions: [],
      adUnitOptions: [],
      normalUsers: [],
      filters: {
        userId: "",
        website: "",
        country: "",
        adUnit: "",
        start: thirtyDaysAgo.toISOString().slice(0, 10),
        end: today.toISOString().slice(0, 10),
        dimensions: [],
        showDate: true,
      },
    };
  },
  computed: {
    isAdmin() {
      const perms = JSON.parse(localStorage.getItem("perms") || "[]");
      return perms.includes("website:manage");
    },
    totals() {
      if (!this.rows.length) return null;
      const t = { requests: 0, matched_requests: 0, impressions: 0, clicks: 0,
                  pre_share_revenue: 0, post_share_revenue: 0, actual_revenue: 0, profit: 0 };
      for (const r of this.rows) {
        t.requests         += r.requests          || 0;
        t.matched_requests += r.matched_requests  || 0;
        t.impressions      += r.impressions       || 0;
        t.clicks           += r.clicks            || 0;
        t.pre_share_revenue  += r.pre_share_revenue  || 0;
        t.post_share_revenue += r.post_share_revenue || 0;
        t.actual_revenue   += r.actual_revenue    || 0;
        t.profit           += r.profit            || 0;
      }
      return t;
    },
  },
  async created() {
    const tasks = [this.loadWebsiteOptions(), this.loadOptions()];
    if (this.isAdmin) tasks.push(this.loadUsers());
    await Promise.all(tasks);
    await this.loadData();
  },
  methods: {
    async loadWebsiteOptions(userId = "") {
      try {
        const params = userId ? { user_id: userId } : {};
        const data = await fetchRevenueWebsites(params);
        this.websiteOptions = data || [];
      } catch (e) {
        console.error(e);
      }
    },
    async loadUsers() {
      try {
        const data = await fetchUsers();
        // 只显示普通账号（非超级管理员，role_id !== 1）
        this.normalUsers = (data || []).filter(u => u.role_id !== 1);
      } catch (e) {
        console.error(e);
      }
    },
    async onUserChange() {
      this.filters.website = "";
      this.filters.country = "";
      this.filters.adUnit = "";
      this.countryOptions = [];
      this.adUnitOptions = [];
      await this.loadWebsiteOptions(this.filters.userId);
    },
    async onWebsiteChange() {
      this.filters.country = "";
      this.filters.adUnit = "";
      await this.loadOptions();
      await this.loadData();
    },
    async loadOptions() {
      try {
        const params = {
          start: this.filters.start,
          end: this.filters.end,
        };
        if (this.filters.website) params.website = this.filters.website;
        if (this.isAdmin && this.filters.userId) params.user_id = this.filters.userId;
        const data = await fetchRevenueOptions(params);
        this.countryOptions = data.countries || [];
        this.adUnitOptions = data.ad_units || [];
        // 若数据不含国家/广告位字段，自动取消对应维度勾选
        if (this.countryOptions.length === 0) {
          this.filters.dimensions = this.filters.dimensions.filter((d) => d !== "country");
        }
        if (this.adUnitOptions.length === 0) {
          this.filters.dimensions = this.filters.dimensions.filter((d) => d !== "adunit");
        }
      } catch (e) {
        console.error("[options]", e);
        this.countryOptions = [];
        this.adUnitOptions = [];
        this.filters.dimensions = [];
      }
    },
    async loadData() {
      this.tableLoading = true;
      this.error = null;
      try {
        const params = {
          start: this.filters.start,
          end: this.filters.end,
        };
        if (this.filters.website) params.website = this.filters.website;
        if (this.filters.country) params.country = this.filters.country;
        if (this.filters.adUnit) params.ad_unit = this.filters.adUnit;
        if (this.filters.dimensions.length > 0) params.dimension = this.filters.dimensions.join(",");
        if (!this.filters.showDate) params.no_date = "1";
        if (this.isAdmin && this.filters.userId) params.user_id = this.filters.userId;

        const data = await fetchRevenueList(params);
        this.rows = (data && data.data) || [];
      } catch (e) {
        console.error("[DataTables] 数据加载失败:", e);
        this.error = e.message;
      } finally {
        this.tableLoading = false;
      }
    },
    formatAmount(val) {
      if (!val && val !== 0) return "$0.00";
      return "$" + Number(val).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatECPM(val) {
      if (val === null || val === undefined) return "-";
      return Number(val).toFixed(4);
    },
    formatPct(val) {
      if (!val && val !== 0) return "0.00%";
      return Number(val).toFixed(2) + "%";
    },
    exportCSV() {
      const byCountry = this.filters.dimensions.includes("country");
      const byAdUnit  = this.filters.dimensions.includes("adunit");
      const showDate  = this.filters.showDate;

      // 构造表头
      const headers = [];
      if (byCountry) headers.push("国家");
      if (byAdUnit)  headers.push("广告位");
      headers.push("网站");
      if (showDate)  headers.push("日期");
      headers.push("请求", "匹配请求", "覆盖率", "曝光数", "点击数", "CTR");
      if (this.isAdmin) headers.push("原eCPM");
      headers.push("eCPM", "分成前收益", "分成后收益");
      if (this.isAdmin) headers.push("实际收益", "利润");
      headers.push("曝光率");

      const escape = (v) => {
        const s = v == null ? "" : String(v);
        return s.includes(",") || s.includes('"') || s.includes("\n")
          ? '"' + s.replace(/"/g, '""') + '"'
          : s;
      };

      const rowToArr = (r) => {
        const cells = [];
        if (byCountry) cells.push(r.country || "-");
        if (byAdUnit)  cells.push(r.ad_unit  || "-");
        cells.push(r.website);
        if (showDate)  cells.push(r.date || "");
        cells.push(r.requests, r.matched_requests, this.formatPct(r.coverage),
                   r.impressions, r.clicks, this.formatPct(r.ctr));
        if (this.isAdmin) cells.push(this.formatECPM(r.original_ecpm));
        cells.push(this.formatECPM(r.ecpm),
                   this.formatAmount(r.pre_share_revenue),
                   this.formatAmount(r.post_share_revenue));
        if (this.isAdmin) {
          cells.push(this.formatAmount(r.actual_revenue), this.formatAmount(r.profit));
        }
        cells.push(this.formatPct(r.fill_rate));
        return cells;
      };

      const lines = [headers.map(escape).join(",")];
      for (const r of this.rows) {
        lines.push(rowToArr(r).map(escape).join(","));
      }

      // 合计行
      if (this.totals) {
        const t = this.totals;
        const tCells = [];
        const dimCount = (byCountry ? 1 : 0) + (byAdUnit ? 1 : 0) + (showDate ? 1 : 0);
        // 前几列（维度+网站+日期）：第一格写"合计"，其余留空
        tCells.push("合计");
        for (let i = 0; i < dimCount; i++) tCells.push("");
        tCells.push(t.requests, t.matched_requests, "—",
                    t.impressions, t.clicks, "—");
        if (this.isAdmin) tCells.push("—");
        tCells.push("—", this.formatAmount(t.pre_share_revenue), this.formatAmount(t.post_share_revenue));
        if (this.isAdmin) {
          tCells.push(this.formatAmount(t.actual_revenue), this.formatAmount(t.profit));
        }
        tCells.push("—");
        lines.push(tCells.map(escape).join(","));
      }

      const blob = new Blob(["﻿" + lines.join("\r\n")], { type: "text/csv;charset=utf-8" });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      const dateRange = `${this.filters.start}_${this.filters.end}`;
      a.href     = url;
      a.download = `数据报表_${dateRange}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
/* 国家/广告位下拉框出现动画 */
.filter-drop-enter-active {
  transition: opacity 0.28s ease, transform 0.28s ease;
}
.filter-drop-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.filter-drop-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.filter-drop-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* 骨架屏 shimmer */
.skeleton-row { height: 18px; }
.skeleton-cell {
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, #e8e8e8 25%, #d0d0d0 50%, #e8e8e8 75%);
  background-size: 600px 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}
@keyframes shimmer {
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
}

/* 合计行 */
.total-row td {
  border-top: 2px solid #dee2e6;
  background-color: #f8f9fa;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
